import { render } from "./CardShowcaseButton.vue?vue&type=template&id=18e09636&scoped=true"
import script from "./CardShowcaseButton.vue?vue&type=script&lang=js"
export * from "./CardShowcaseButton.vue?vue&type=script&lang=js"

import "./CardShowcaseButton.vue?vue&type=style&index=0&id=18e09636&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e09636"]])

export default __exports__